export default __webpack_public_path__ + "static/gitex_banner-8c84a71db6b3b104aa2f1703c9cd9178.png";